import 'regenerator-runtime'
import lottie from 'lottie-web'
import helper from './helper'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const homePageCarousel = {
    $window: $(window),
    $headerWrapper: $('.js-homepage-carousel-wrapper'),
    lottieWrappers: $('.js-lottie-hero-home'),
    lottieObjects: null,
    currentPosition: 0,
    newPosition: null,
    direction: null,
    isSlidingFlag: false,
    isSwipeTrueFlag: false,
    $bgScenes: $('.js-bg-scene'),
    $fgScenes: $('.js-fg-scene'),
    $titles: $('.js-header-title'),
    $controlButtons: $('.js-control-button button'),
    $arrowPrev: $('.js-arrow-prev'),
    $arrowNext: $('.js-arrow-next'),
    animationDuration: 4000,
    mobileAnimationDuration: 2000,
    intervalTime: 12000,
    pauseTime: 180000, // 180000 = 3 minutes
    pauseInterval: null,
    timer: null,
    init: function () {
        let _this = this

        _this.pauseInterval = setTimeout(() => {
            pauseAllAnimations()
        }, _this.pauseTime)

        // Init and store lotties
        this.lottieObjects = _this.lottieWrappers.map((index, item) => {
            const lottieObj = initLottie(item)
            lottieObj.addEventListener('data_ready', () =>
                $(item).addClass('lottie-loaded')
            )
            return lottieObj
        })

        // Attach and detach swipe functions for mobile
        _this.$window.on('load resize', () => {
            if (_this.$window.width() <= 1024 && !_this.isSwipeTrueFlag) {
                helper.handleGesture('#targetArea', true, handleSwipeEvents)
                _this.isSwipeTrueFlag = true
            }

            if (_this.$window.width() > 1024 && _this.isSwipeTrueFlag) {
                helper.handleGesture('#targetArea', false, handleSwipeEvents)
                _this.isSwipeTrueFlag = false
            }
        })

        $(document).ready(() => {
            // Initial fade in effect for scene 0
            $(_this.$fgScenes[0]).addClass('fade-in-in-place')
            $(_this.$bgScenes[0]).css('opacity', '1')
            $(_this.$titles[0]).css('opacity', '1')
            setTimeout(() => {
                $(_this.$fgScenes[0])
                    .removeClass('fade-in-in-place')
                    .addClass('current')
            }, 2500)
        })

        // Folder animation init
        const anim = lottie.loadAnimation({
            container: document.getElementById('lottieFolder'),
            renderer: 'svg',
            loop: true,
            autoplay: false,
            path: '/img/lottie/home-page/animations/folder-animation.json',
            rendererSettings: {
                preserveAspectRatio: 'xMinYMax meet',
            },
        })
        anim.setSpeed(0.9)
        anim.addEventListener('DOMLoaded', function () {
            anim.playSegments([1, 299], true)
        })

        // Ring animation init
        const ringAnim = lottie.loadAnimation({
            container: document.getElementById('lottieRing'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: '/img/lottie/home-page/animations/ring.json',
            rendererSettings: {
                preserveAspectRatio: 'xMinYMax meet',
            },
        })
        ringAnim.setSpeed(1)

        // Carousel logic
        _this.$controlButtons.on(
            'click customAutoPlayEvent custumGoToFirstScene',
            ev => {
                let $target = $(ev.target)

                if (_this.isSlidingFlag) {
                    return
                }

                // We do not play the animations again in case we simply slide to the first scene after pausing the animations/the carousel
                if (ev.type === 'click') {
                    playAllAnimations()
                }

                // Get new position
                _this.newPosition = $target.data('position')
                if (_this.currentPosition === _this.newPosition) {
                    return
                }

                if (ev.type === 'click') {
                    clearInterval(_this.timer)
                }
                async function asyncCall() {
                    await Promise.all([
                        animationStart(ev),
                        animationEnd(),
                        animationReset(),
                    ])
                }
                asyncCall()
            }
        )

        // Autoplay
        _this.timer = setInterval(() => runInterval(), _this.intervalTime)

        // Arrow funstions
        _this.$arrowNext.on('click', () => {
            if (_this.isSlidingFlag == true) {
                return
            }
            $(
                _this.$controlButtons[
                    _this.currentPosition == 2 ? 0 : _this.currentPosition + 1
                ]
            ).trigger('click')
        })

        _this.$arrowPrev.on('click', () => {
            if (_this.isSlidingFlag == true) {
                return
            }
            $(
                _this.$controlButtons[
                    _this.currentPosition == 0 ? 2 : _this.currentPosition - 1
                ]
            ).trigger('click')
        })

        // Reset animation on scroll
        ScrollTrigger.create({
            trigger: _this.$headerWrapper,
            start: 'top bottom',
            end: 'bottom top',
            onEnterBack: ({ direction, isActive }) => {
                if (isActive) {
                    playAllAnimations()
                    _this.timer = setInterval(
                        () => runInterval(),
                        _this.intervalTime
                    )
                }
            },
            onLeave: ({ direction, isActive }) => {
                pauseAllAnimations('pauseOnScroll')
            },
        })

        function playFolderAnimation() {
            if (_this.direction === 'right') {
                if (_this.currentPosition == 0) {
                    playLottieSegments([300, 390], [391, 499])
                } else if (_this.currentPosition == 1) {
                    playLottieSegments([491, 550], [551, 659])
                } else if (_this.currentPosition == 2) {
                    playLottieSegments([651, 717], [1, 299])
                }
            }

            if (_this.direction === 'left') {
                if (_this.currentPosition == 0) {
                    playLottieSegments([717, 651], [551, 659])
                } else if (_this.currentPosition == 1) {
                    playLottieSegments([390, 299], [1, 299])
                } else if (_this.currentPosition == 2) {
                    playLottieSegments([550, 491], [391, 499])
                }
            }
        }

        function animationStart(ev) {
            return new Promise(resolve => {
                _this.isSlidingFlag = true
                setPositions(ev)

                playFolderAnimation()

                // Ring
                if (_this.direction == 'right') {
                    ringAnim.setSpeed(5)
                } else {
                    ringAnim.setSpeed(-5)
                }

                // Update buttons styles
                $(_this.$controlButtons).parent().removeClass('slick-active')
                $(_this.$controlButtons).parent().addClass('disabled')
                $(_this.$controlButtons[_this.newPosition])
                    .parent()
                    .addClass('slick-active')
                //Background hide
                $(_this.$bgScenes[_this.currentPosition]).css('opacity', '0')

                // Title hide
                $(_this.$titles[_this.currentPosition]).css('opacity', '0')

                // Foreground animation
                if (_this.direction === 'right') {
                    $(_this.$fgScenes[_this.currentPosition]).addClass(
                        'fade-out-to-left'
                    )
                    $(_this.$fgScenes[_this.newPosition]).addClass(
                        'fade-in-from-right'
                    )
                } else {
                    $(_this.$fgScenes[_this.currentPosition]).addClass(
                        'fade-out-to-right'
                    )
                    $(_this.$fgScenes[_this.newPosition]).addClass(
                        'fade-in-from-left'
                    )
                }
            })
        }

        function animationEnd() {
            return new Promise(resolve => {
                setTimeout(() => {
                    //Bg
                    $(_this.$bgScenes[_this.newPosition]).css('opacity', '1')

                    //Title
                    $(_this.$titles[_this.newPosition]).css('opacity', '1')
                    // Ring
                    if (_this.direction == 'right') {
                        updateSpeed(5, 1, 1)
                    } else {
                        updateSpeed(5, 1, -1)
                    }
                }, setAnimationDuration() / 3)
                setTimeout(() => {
                    // Fg
                    $(_this.$fgScenes[_this.currentPosition]).removeClass(
                        'current'
                    )
                    $(_this.$fgScenes[_this.newPosition]).addClass('current')
                    $(_this.$fgScenes).removeClassStartingWith('fade')
                }, setAnimationDuration())
            })
        }

        function animationReset() {
            return new Promise(resolve => {
                setTimeout(() => {
                    _this.currentPosition = _this.newPosition
                    _this.newPosition = null
                    _this.isSlidingFlag = false
                    $(_this.$controlButtons).parent().removeClass('disabled')
                }, setAnimationDuration())
            })
        }

        function updateSpeed(initialSpeed, endSpeed, direction) {
            let newSpeed = initialSpeed - 1
            ringAnim.setSpeed(newSpeed * direction)
            setTimeout(() => {
                if (newSpeed > endSpeed) {
                    updateSpeed(newSpeed, endSpeed, direction)
                }
            }, 500)
        }

        function setPositions(ev) {
            let $target = $(ev.target)
            // Get new position
            _this.newPosition = $target.data('position')
            // Set direction
            _this.direction =
                _this.newPosition > _this.currentPosition
                    ? (_this.direction = 'right')
                    : (_this.direction = 'left')
            // Extra rule - the user cannot go from scene 1 to scene 3, instead he will go to scene 2
            if (_this.currentPosition === 0 && _this.newPosition === 2) {
                _this.direction = 'left'
            }
            if (_this.currentPosition === 2 && _this.newPosition === 0) {
                _this.direction = 'right'
            }
        }

        function runInterval() {
            if (
                helper.isElementInViewport(
                    _this.$headerWrapper,
                    'partialInView'
                )
            ) {
                $(
                    _this.$controlButtons[
                        _this.currentPosition == 2
                            ? 0
                            : _this.currentPosition + 1
                    ]
                ).trigger('customAutoPlayEvent')
            }
        }

        function handleSwipeEvents(ev) {
            let direction = ev
            if (direction.includes('left')) {
                _this.$arrowNext.trigger('click')
            }
            if (direction.includes('right')) {
                _this.$arrowPrev.trigger('click')
            }
        }
        function pauseAllAnimations(type = 'default') {
            anim.loop = false
            anim.pause()
            ringAnim.loop = false
            ringAnim.pause()
            // Stop autoplay
            clearInterval(_this.timer)
            // After pausing the animation if it is not on the first scene, we trigger click and slide it to the first scene
            if (_this.currentPosition !== 0 && type !== 'pauseOnScroll') {
                if (_this.isSlidingFlag) {
                    setTimeout(() => {
                        $(_this.$controlButtons[0]).trigger(
                            'custumGoToFirstScene'
                        )
                        anim.playSegments([0, 280], true)
                        anim.loop = false
                    }, _this.setAnimationDuration())
                } else {
                    $(_this.$controlButtons[0]).trigger('custumGoToFirstScene')
                    anim.playSegments([0, 280], true)
                    anim.loop = false
                }
            }
            _this.lottieObjects.map((index, item) => item.pause())
        }

        function playAllAnimations() {
            anim.loop = true
            anim.play()
            ringAnim.loop = true
            ringAnim.play()

            _this.lottieObjects.map((index, item) => item.play())
            clearTimeout(_this.pauseInterval)
            _this.pauseInterval = setTimeout(() => {
                pauseAllAnimations()
            }, _this.pauseTime)
        }

        function initLottie(lottieWrapper) {
            const { name, path, aspectratio } = lottieWrapper.dataset
            return lottie.loadAnimation({
                container: lottieWrapper,
                renderer: 'svg',
                name,
                path,
                rendererSettings: {
                    preserveAspectRatio: aspectratio
                        ? aspectratio
                        : 'xMinYMax meet',
                    progressiveLoad: true,
                },
                autoplay: true,
            })
        }

        function playLottieSegments(transitionFrames, loopFrames) {
            anim.loop = false
            anim.playSegments([transitionFrames, loopFrames], true)
            anim.loop = true
        }

        function setAnimationDuration() {
            let result
            if (_this.$window.width() <= 768) {
                result = _this.mobileAnimationDuration
                $(':root').css(
                    '--animation-speed',
                    _this.mobileAnimationDuration + 'ms'
                )
            } else {
                result = _this.animationDuration
                $(':root').css(
                    '--animation-speed',
                    _this.animationDuration + 'ms'
                )
            }
            return result
        }

        // Util functions added to jquery
        $.fn.removeClassStartingWith = function (filter) {
            $(this).removeClass(function (index, className) {
                return (
                    className.match(
                        new RegExp('\\S*' + filter + '\\S*', 'g')
                    ) || []
                ).join(' ')
            })
            return this
        }
    },
}

if ($('.js-homepage-carousel-wrapper').length) {
    homePageCarousel.init()
}
